module.exports = __webpack_public_path__ + "static/media/register-writer.467861ce.svg";